export const PlanPendingPaymentText = 'Pagamento Pendente';
export const VigencyText = 'Vigência';
export const AdvertiserNameText = 'Nome do estabelecimento';
export const ChangePaymentMethodText = 'Trocar forma de pagamento';
export const CPFCNPJText = 'CPF ou CNPJ';
export const SignatureMonthlyAmountText = 'Valor da assinatura mensal';
export const SignatureTotalAmountText = 'Valor total da assinatura';
export const SignatureMonthlyInstalmentsText = 'x de ';
export const CopyPaymentCodeText = 'Copiar o código para pagar';
